/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPlus12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlus12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="M6.5 5.5v-4h-1v4h-4v1h4v4h1v-4h4v-1h-4Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconPlus16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlus16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M8.667 7.333V2H7.333v5.333H2v1.334h5.333V14h1.334V8.667H14V7.333H8.667Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconPlus20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlus20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10.833 9.167V2.5H9.167v6.667H2.5v1.666h6.667V17.5h1.666v-6.667H17.5V9.167h-6.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlus24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlus24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M13 11V3h-2v8H3v2h8v8h2v-8h8v-2h-8Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconPlus = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlus(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconPlus12 {...iconProps} />;
        case '16':
            return <IconPlus16 {...iconProps} />;
        case '20':
            return <IconPlus20 {...iconProps} />;
        case '24':
            return <IconPlus24 {...iconProps} />;
        default:
            return <IconPlus24 {...iconProps} />;
    }
});
